module.exports = __webpack_public_path__ + "static/media/CentralLibrary.16b42740.png";